import { render, staticRenderFns } from "./SkeletonMiniWizard.vue?vue&type=template&id=1f78b054&"
import script from "./SkeletonMiniWizard.vue?vue&type=script&lang=js&"
export * from "./SkeletonMiniWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports